<template>
    <div class="status-flow">
      <div :class="['step', { 'step-active': statusIndex >= 1, 'step-pending': statusIndex < 1 }]">
        <div class="step-icon">
          <template v-if="statusIndex > 1">
            <SvgIcon name="check" />
          </template>
          <template v-else>
            1
          </template>
        </div>
        <div class="step-label">Sending</div>
      </div>
      <div class="step-line" :class="{ 'step-active': statusIndex >= 2, 'step-pending': statusIndex < 2 }"></div>
      <div :class="['step', { 'step-active': statusIndex >= 2, 'step-pending': statusIndex < 2 }]">
        <div class="step-icon">
          <template v-if="statusIndex > 2">
            <SvgIcon name="check" />
          </template>
          <template v-else>
            2
          </template>
        </div>
        <div class="step-label">Preparing</div>
      </div>
      <div class="step-line" :class="{ 'step-active': statusIndex >= 3, 'step-pending': statusIndex < 3 }"></div>
      <div :class="['step', { 'step-active': statusIndex >= 3, 'step-void': status === 'VOIDED', 'step-pending': statusIndex < 3 }]">
        <div class="step-icon">
          <template v-if="status === 'VOIDED'">
            <i class="fa fa-times"></i>
          </template>
          <template v-else-if="statusIndex >= 3">
            <SvgIcon name="check" />
          </template>
          <template v-else>
            3
          </template>
        </div>
        <div class="step-label" v-if="status === 'VOIDED'">Voided</div>
        <div class="step-label" v-else>Complete</div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      status: {
        type: String,
        required: true,
        validator: function (value) {
          return ['READY_FOR_CONFIRMATION', 'CONFIRMED', 'FULFILLED', 'VOIDED'].includes(value);
        }
      }
    },
    computed: {
      statusIndex() {
        const statusMap = {
          'READY_FOR_CONFIRMATION': 1,
          'CONFIRMED': 2,
          'FULFILLED': 3,
          'VOIDED': 4
        };
        return statusMap[this.status] || 0;
      }
    }
  }
  </script>
  
  <style scoped>
  .status-flow {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem;
    background-color: #fff;
  }
  
  .step {
    text-align: center;
    position: relative;
  }
  
  .step-icon {
    width: 2.34375rem; /* 37.5px */
    height: 2.34375rem; /* 37.5px */
    line-height: 2.2rem; /* 37.5px */
    border-radius: 50%;
    border: 0.15625rem solid #ccc; /* 2.5px */
    display: inline-block;
    margin-bottom: 0.390625rem; /* 6.25px */
    background-color: #fff;
  }
  
  .step-active .step-icon {
    border-color: #000;
    background-color: #000;
    color: #fff;
  }
  
  .step-void .step-icon {
    border-color: red;
    background-color: red;
    color: #fff;
  }
  
  .step-pending .step-icon {
    border-color: grey;
    background-color: grey;
    color: #fff;
  }
  
  .step-label {
    font-size: 1rem;
    color: #555;
  }
  
  .step-active .step-label {
    font-weight: bold;
    color: #000;
  }
  
  .step-line {
    height: 0.15625rem; /* 2.5px */
    flex: 1;
    background-color: #ccc;
    margin: 0 1rem;
    position: relative;
    bottom: 0.85rem;
  }
  
  .step-active + .step-line {
    background-color: #000;
  }
  
  .step-pending + .step-line {
    background-color: grey;
  }
  </style>
  